export function tieneRol(user: { roles?: string[] } | undefined, ...roles: string[]): boolean {
  return !!user?.roles && roles.some((rol) => user.roles!.includes(rol))
}
